<template>
  <div class="block-title-wrap" :class="className">
    <img class="block-title-logo" v-if="logo" :src="logo" />
    <div class="block-title">
      <h3>{{ title }}</h3>
      <div class="title-desc">{{ desc }}</div>
    </div>
    <!-- <div class="block-slide-bar" v-if="slideBar">
      <div
        v-for="(bar, index) in slideBar"
        :key="index"
        class="block-item"
        @click="switchBar(index)"
        :class="activeIndex === index ? 'active' : ''" 
      >
        <div class="item-text">{{bar.name}}</div>
        <div class="item-bar"></div>
      </div>
    </div> -->
    <div class="block-more">
      <slot />
    </div>
  </div>
</template>

<script>
import newsImg from '../assets/images/block-news.png';
import activityImg from '../assets/images/block-activity.png';
import engineeringImg from '../assets/images/block-engineering.png';
import policyImg from '../assets/images/block-policy.png';
import journalImg from '../assets/images/block-journal.png';
import touristImg from '../assets/images/block-tourist.png';
import cityImg from '../assets/images/block-city.png';
import memberImg from '../assets/images/block-member.png';

const config = {
  news: {
    logo: newsImg,
    title: "新闻动态",
    desc: "news",
    // slideBar: [
    //   {
    //     name: "学会工作简讯",
    //   },
    //   {
    //     name: "省外动态信息",
    //   },
    // ]
  },
  activity: {
    logo: activityImg,
    title: "活动剪影",
    desc: "Activity silhouette",
    slideBar: [
      {
        name: "培训",
      },
      {
        name: "会议",
      },
      {
        name: "沙龙",
      },
    ]
  },
  engineering: {
    logo: engineeringImg,
    title: '等级评价',
    slideBar: [],
    desc: 'E Award',
    more: ''
  },
  policy: {
    logo: policyImg,
    title: "政策法规",
    slideBar: [],
    desc: "Policy and law",
  },
  journal: {
    logo: journalImg,
    title: "编辑出版",
    slideBar: [],
    desc: "Publication"
  },
  tourist: {
    logo: touristImg,
    title: "风景名胜",
    slideBar: [],
    desc: "Famous scenery"
  },
  city: {
    logo: cityImg,
    title: "园林城市",
    slideBar: [],
    desc: "Garden city"
  },
  member: {
    logo: memberImg,
    title: "会员之家",
    slideBar: [],
    desc: "Member House"
  },
  hottrain: {
    className: 'block-title-wrap-about',
    title: "热门培训",
    slideBar: [],
    desc: "Activity & Hot"
  },
  meeting: {
    className: 'block-title-wrap-about',
    title: "近期会议",
    desc: "Latest meeting",
    slideBar: []
  },
  great: {
    className: 'block-title-wrap-about',
    title: "等级评价",
    desc: "Latest award",
    slideBar: []
  },
  salon: {
    className: 'block-title-wrap-about',
    title: "沙龙",
    desc: "Latest salon",
    slideBar: []
  },
  contribution: {
    className: 'block-title-wrap-about',
    title: "学会投稿",
    desc: "Contribution",
    slideBar: []
  },
  publish: {
    className: 'block-title-wrap-about',
    title: "编辑出版",
    desc: "Publication",
    slideBar: [],
  }
};
export default {
  data() {
    return {
      activeIndex: 0,
      logo: '',
      className: '',
      ...config[this.titleType],
    };
  },
  props: {
    titleType: {
      require: true,
      default: "news",
      type: String,
    },
  },
  methods: {
    switchBar(id) {
      this.activeIndex = id;
      this.$emit('onSwitchTab', id);
    }
  }
};
</script>

<style lang="less" scoped>
.block-title-wrap {
  display: flex;
  align-items: center;
  height: 70px;
  margin-bottom: 20px;

  &-about {
    height: 45px;
    align-items: baseline;

    .block-title {
      display: flex;
      align-items: baseline;
      
      h3 {
        margin-right: 20px;
      }

    }
  }

  .block-title-logo {
    display: block;
    width: 70px;
    height: 70px;
    margin-right: 18px;
  }

  .block-title {
    height: 100%;
    margin-right: 72px;

    h3 {
      height: 45px;
      font-size: 32px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #131415;
      line-height: 45px;
    }

    .title-desc {
      height: 25px;
      font-size: 18px;
      font-family: PingFangSC-Semibold, PingFang SC;
      color: #131415;
      opacity: 0.2;
      line-height: 25px;
    }
  }

  .block-slide-bar {
    height: 100%;
    display: flex;
    align-items: center;

    .block-item {
      width: 120px;
      text-align: center;
      height: 20px;
      font-size: 14px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 600;
      color: #131415;
      line-height: 20px;
      cursor: pointer;

      .item-text {
        margin-bottom: 4px;
      }

      .item-bar {
        width: 100%;
        height: 6px;
        background: #f1f3f3;
      }

      &:hover,
      &.active {
        color: #06ae63;

        .item-bar {
          background: #06ae63;
        }
      }
    }
  }

  .block-more {
    margin-left: auto;
    height: 25px;
    font-size: 18px;
    font-family: PingFangSC-Medium, PingFang SC;
    color: #9d9e9e;
    line-height: 25px;
    cursor: pointer;
  }
}
</style>